import ApplicationSettingsTab from './application-settings';

export default ApplicationSettingsTab;
